import script from "./Loan.vue?vue&type=script&setup=true&lang=ts"
export * from "./Loan.vue?vue&type=script&setup=true&lang=ts"

import "./Loan.vue?vue&type=style&index=0&id=d0ae00c4&scoped=true&lang=css"
import "@/assets/css/scrollbar.css?vue&type=style&index=1&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d0ae00c4"]])

export default __exports__